import React from 'react';
import { LucideIcon } from 'lucide-react';

interface PageHeaderProps {
    /** Slot rendered before the title — e.g. a back button */
    left?: React.ReactNode;
    /** Slot rendered after the title block — e.g. action buttons */
    right?: React.ReactNode;
    /** Bold heading text */
    title: string;
    /** Muted sub-text */
    subtitle?: React.ReactNode;
    /** Extra classes on the outer wrapper */
    className?: string;
    /** Lucide icon — intentionally not rendered, kept for API compat */
    icon?: LucideIcon;
}

/**
 * Standard page-level header — plain text, no card.
 * Use `left` for a back-button, `right` for action buttons.
 */
export const PageHeader: React.FC<PageHeaderProps> = ({
    left,
    right,
    title,
    subtitle,
    className = 'mb-4',
}) => (
    <div className={`d-flex align-items-center justify-content-between gap-3 flex-wrap ${className}`}>
        <div className="d-flex align-items-center gap-3">
            {left}
            <div>
                <h4 className="mb-1 fw-bold text-body-emphasis" style={{ fontSize: '1.25rem' }}>{title}</h4>
                {subtitle && (
                    <p className="mb-0 text-muted" style={{ fontSize: '0.82rem' }}>{subtitle}</p>
                )}
            </div>
        </div>
        {right && (
            <div className="d-flex align-items-center gap-2 flex-shrink-0">
                {right}
            </div>
        )}
    </div>
);

export default PageHeader;
